// URL helpers shared by gatsby-node.js and the components. Kept as CommonJS so
// gatsby-node.js can require() it.

// WordPress slug of the Nom-Nom product page (the same in both languages).
const NOM_NOM_SLUG = 'nom-nom-edible-teether'

const HOME_PATH = { EL: '/', EN: '/en/' }
const POST_BASE = { EL: '/news', EN: '/blog' }
const NEWS_BASE = { EL: '/news', EN: '/en/blog' }

const getHomePath = (lang) => HOME_PATH[lang] || HOME_PATH.EL

// WordPress URIs of English posts already start with `/en/`, so they end up
// under `/blog/en/<slug>/`, while Greek posts live under `/news/<slug>/`.
const getPostPath = (post) => `${POST_BASE[post.language?.code] || POST_BASE.EL}${post.uri}`

const getNewsPath = (lang, page = 1) =>
  `${NEWS_BASE[lang] || NEWS_BASE.EL}/${page > 1 ? `page/${page}/` : ''}`

module.exports = { NOM_NOM_SLUG, getHomePath, getPostPath, getNewsPath }
